export enum LineEnd {
    Round = "Round",
    Butt = "Butt",
    Square = "Square"
}